import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-up",
  "use": "arrow-up-usage",
  "viewBox": "0 0 129 129",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 129 129\" id=\"arrow-up\"><path d=\"M121.4 61.6l-54-54c-.7-.7-1.8-1.2-2.9-1.2s-2.2.5-2.9 1.2l-54 54c-1.6 1.6-1.6 4.2 0 5.8.8.8 1.8 1.2 2.9 1.2s2.1-.4 2.9-1.2l47-47v98.1c0 2.3 1.8 4.1 4.1 4.1s4.1-1.8 4.1-4.1V20.4l47 47c1.6 1.6 4.2 1.6 5.8 0s1.5-4.2 0-5.8z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol